import { createEntityAdapter, createSelector, createSlice } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';

import {
  createAutoShares,
  loadAutoShares,
  loadVirtualMemberships,
  removeAutoShares,
  shareVirtualAccess,
  unshareVirtualAccess,
} from './api';
import { VirtualMembersipSchema, AutoShareSchema } from './schema';

const virtualMembershipAdapter = createEntityAdapter();
const autoShareAdapter = createEntityAdapter();

const virtualSlice = createSlice({
  name: 'virtual',
  initialState: {
    memberships: virtualMembershipAdapter.getInitialState({}),
    autoShares: autoShareAdapter.getInitialState({}),
  },
  reducers: {
    setPage(state, action) {
      state.view.page = action.payload;
    },
    setSearch(state, action) {
      state.view.search = action.payload;
    },
    setOrder(state, action) {
      state.view.order = action.payload;
    },
    setOrderBy(state, action) {
      state.view.orderBy = action.payload;
    },
  },
  extraReducers: builder =>
    builder
      .addCase(loadVirtualMemberships.fulfilled, (state, action) => {
        const { entities } = normalize(action.payload.results, [VirtualMembersipSchema]);
        virtualMembershipAdapter.upsertMany(state.memberships, entities.virtualMemberships ?? {});
      })
      .addCase(shareVirtualAccess.fulfilled, (state, action) => {
        const { entities } = normalize(action.payload, [VirtualMembersipSchema]);
        virtualMembershipAdapter.upsertMany(state.memberships, entities.virtualMemberships ?? {});
      })
      .addCase(unshareVirtualAccess.fulfilled, (state, action) => {
        const requestedMembershipIds = action.meta.arg.map(signature => signature.id).filter(id => id != null);
        virtualMembershipAdapter.removeMany(state.memberships, [...action.payload, ...requestedMembershipIds]);
      })
      .addCase(loadAutoShares.fulfilled, (state, action) => {
        console.log(action.payload);
        const { entities } = normalize(action.payload.results, [AutoShareSchema]);
        autoShareAdapter.upsertMany(state.autoShares, entities.autoShares ?? {});
      })
      .addCase(createAutoShares.fulfilled, (state, action) => {
        const { entities } = normalize(action.payload, [AutoShareSchema]);
        autoShareAdapter.upsertMany(state.autoShares, entities.autoShares ?? {});
      })
      .addCase(removeAutoShares.fulfilled, (state, action) => {
        autoShareAdapter.removeMany(state.autoShares, action.meta.arg);
      }),
});

export const selectVirtualMembershipEntities = state => {
  return state.virtual.memberships.entities;
};

export const selectAutoShareEntities = state => {
  return state.virtual.autoShares.entities;
};

export const selectAutoSharesBySiteGroupId = siteGroupId =>
  createSelector(selectAutoShareEntities, autoShares =>
    Object.values(autoShares).filter(autoShare => autoShare.site_group.id == siteGroupId),
  );

export const selectVirtualMembershipsBySiteId = siteId =>
  createSelector(selectVirtualMembershipEntities, memberships =>
    Object.values(memberships).filter(membership => membership.site.id == siteId),
  );

export const { selectById: selectVirtualMembershipById } = virtualMembershipAdapter.getSelectors(
  selectVirtualMembershipEntities,
);

const { reducer } = virtualSlice;
export default reducer;
